import { useState } from "react";
import { useTranslation } from "react-i18next";

function ErrorFallback({ error, componentStack, onReset }) {
    const { t } = useTranslation();
    const [showDetails, setShowDetails] = useState(false);

    return (
        <div className="flex h-screen w-full items-center justify-center bg-background p-4">
            <div className="flex w-full max-w-lg flex-col items-center gap-6 text-center">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-8 w-8 text-destructive"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                    </svg>
                </div>
                <div className="flex flex-col gap-2">
                    <h1 className="text-xl font-semibold text-foreground">
                        {t("errorBoundary.title")}
                    </h1>
                    <p className="text-sm text-muted-foreground">
                        {t("errorBoundary.description")}
                    </p>
                </div>
                <div className="flex gap-3">
                    <button
                        onClick={() => setShowDetails((v) => !v)}
                        className="inline-flex items-center justify-center rounded-md border border-input bg-background px-4 py-2.5 text-sm font-medium text-foreground shadow-sm transition-colors hover:bg-accent"
                    >
                        {showDetails
                            ? t("errorBoundary.hideDetails")
                            : t("errorBoundary.showDetails")}
                    </button>
                    <button
                        onClick={onReset}
                        className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-2.5 text-sm font-medium text-primary-foreground shadow-sm transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                    >
                        {t("errorBoundary.reload")}
                    </button>
                </div>
                {showDetails && (
                    <div className="w-full rounded-md border border-border bg-muted/50 p-4 text-left">
                        <p className="mb-2 text-sm font-medium text-destructive">
                            {error?.message}
                        </p>
                        <pre className="max-h-48 overflow-auto whitespace-pre-wrap text-xs text-muted-foreground">
                            {componentStack}
                        </pre>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ErrorFallback;
